var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 358,
    height: 100,
    viewBox: "0 0 358 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H358V100H0L27.142 59.2871C30.6952 53.9572 30.7271 47.0218 27.223 41.6594L0 0Z",
    fill: "#37D001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGreen);
export default __webpack_public_path__ + "static/media/messageGreen.004a24c18266c0342f74bf243ec90faa.svg";
export { ForwardRef as ReactComponent };